import { render } from "./XeroPage.vue?vue&type=template&id=1d2b3c3e&scoped=true"
import script from "./XeroPage.vue?vue&type=script&lang=js"
export * from "./XeroPage.vue?vue&type=script&lang=js"

import "./XeroPage.vue?vue&type=style&index=0&id=1d2b3c3e&scoped=true&lang=css"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2b3c3e"]])

export default __exports__